import React from 'react';

const GameStats = ({ game }) => {
  const rating = game.bgg_data?.bgg_average_rating;
  const weight = game.bgg_data?.bgg_average_weight;

  const renderPlaytime = () => {
    const { playing_time, combined_min_playtime, combined_max_playtime } = game;

    if (combined_min_playtime && combined_max_playtime) {
      if (combined_min_playtime === combined_max_playtime) {
        return `${combined_min_playtime} min`;
      }
      return `${combined_min_playtime} - ${combined_max_playtime} min`;
    }

    return `${playing_time || 'N/A'} min`;
  };

  const renderPlayerCount = () => {
    const { min_players, max_players, combined_min_players, combined_max_players } = game;
    const min = combined_min_players ?? min_players;
    const max = combined_max_players ?? max_players;

    if (min === max) {
      return `${min || 'N/A'}`;
    }
    return `${min || 'N/A'}-${max || 'N/A'}`;
  };

  return (
    <div className="game-stats-lines">
      <p>
        <small>
          <span title="Player Count">
            👥 {renderPlayerCount()}
            {game.bgg_data?.bgg_best_players && ` (Best: ${game.bgg_data.bgg_best_players})`}
          </span>
        </small>
      </p>
      <p>
        <small>
          <span title="Playing Time">🕒 {renderPlaytime()}</span>
        </small>
      </p>
      {rating > 0 && (
        <p>
          <small>
            <span title={`Average BGG Rating: ${rating.toFixed(1)} / 10`}>⭐ {rating.toFixed(1)}</span>
          </small>
        </p>
      )}
      {weight > 0 && (
        <p>
          <small>
            <span title={`BGG Weight (Complexity): ${weight.toFixed(2)} / 5`}>⚖️ {weight.toFixed(2)}</span>
          </small>
        </p>
      )}
    </div>
  );
};

export default GameStats;